export default __webpack_public_path__ + "static/media/doc.5cf7c5f2.svg";